import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { cx } from 'class-variance-authority';
type TableCellProps = {
  className?: string;
  size?: string;
  children: ReactNode;
  onClick?: React.MouseEventHandler<HTMLTableCellElement>;
};
export default function TableCell(t0) {
  const $ = _c(8);
  const {
    className,
    size: t1,
    children,
    onClick
  } = t0;
  const size = t1 === undefined ? "default" : t1;
  const t2 = size === "default" && "px-3 py-5";
  const t3 = size === "small" && "px-2 py-3";
  let t4;
  if ($[0] !== className || $[1] !== t2 || $[2] !== t3) {
    t4 = cx("whitespace-no-wrap relative text-primary", t2, t3, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== children || $[5] !== onClick || $[6] !== t4) {
    t5 = <td onClick={onClick} className={t4}>{children}</td>;
    $[4] = children;
    $[5] = onClick;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}